// @flow

/* Libs */
import { useEffect, useState } from 'react';
import {
	Link,
	useParams,
	useLocation,
	useHistory
} from 'react-router-dom';

/* Stores */
import useFurnituresCategoriesStore from 'Stores/FurnituresCategories';
import useFurnituresStore from 'Stores/Furnitures';
import useModalStore from 'Stores/Modals';

/* Components */
import Icon from 'Components/Icon';
import BackArrow from 'Components/BackArrow';

const CategoryFurnitures = () => {
	// Modal
	const setActiveModal = useModalStore(store => store.setActiveModal);

	// Categories
	const categories = useFurnituresCategoriesStore(store => store.categories);
	const fetchCategories = useFurnituresCategoriesStore(store => store.fetchCategories);

	// Furnitures
	const furnitures = useFurnituresStore(store => store.furnitures);
	const currentFurnitures = useFurnituresStore(store => store.currentFurnitures);
	const fetchFurnitures = useFurnituresStore(store => store.fetchFurnitures);
	const fetchingFurnitures = useFurnituresStore(store => store.fetchingFurnitures);
	const getCurrentFurnitures = useFurnituresStore(store => store.getCurrentFurnitures);

	// Current state
	const [currentCategory, setCurrentCategory] = useState(null);
	const [filteredFurnitures, setFilteredFurnitures] = useState(null);
	const [searchQuery, setSearchQuery] = useState('');
	const [displaySearch, setDisplaySearch] = useState(false);

	// params
	const { categoryid, furnitureid } = useParams();
	const { pathname } = useLocation();
	const history = useHistory();

	useEffect(() => {
		if (furnitureid) {
			setActiveModal('showFurniture', { furnitureid });
		}
	}, []);

	useEffect(() => {
		if (pathname.includes(`/furnitures/${categoryid}/new`)) {
			setActiveModal('createFurniture', { categoryid });
		}
	}, [pathname]);

	useEffect(() => {
		if (furnitureid) {
			setActiveModal('showFurniture', { furnitureid });
		}
	}, [furnitureid]);

	useEffect(() => {
		if (!categories) {
			fetchCategories();
		} else {
			if (!furnitures && !fetchingFurnitures) {
				fetchFurnitures();
			}
			if (!currentCategory) {
				const category = categories.find(categ => categ.id === categoryid);
				setCurrentCategory(category);
			}
		}
	}, [categories, furnitures, fetchingFurnitures, currentCategory, categoryid]);

	useEffect(() => {
		if (furnitures) {
			getCurrentFurnitures(categoryid);
		}
	}, [furnitures, categoryid, getCurrentFurnitures]);

	useEffect(() => {
		if (currentFurnitures) {
			if (searchQuery.length > 0) {
				const filtered = currentFurnitures.filter(furniture => furniture.name.toLowerCase().includes(searchQuery));
				setFilteredFurnitures(filtered);
			} else {
				setFilteredFurnitures(currentFurnitures);
			}
		}
	}, [searchQuery, currentFurnitures]);

	const getClassFromName = (name) => {
		let className = '';
		const namelow = name.toLowerCase();

		if (namelow.includes('or')) {
			className = 'or';
		}

		if (namelow.includes('argent')) {
			className = 'argent';
		}

		return className;
	};

	const getName = (name) => {
		const nameSplit = name.split(' - ');
		const title = nameSplit[0] || 'Fourniture sans nom';
		nameSplit.shift();
		const tags = nameSplit;

		return (
			<div className="furniture-title">
				<p>{title}</p>
				<div className="tags">
					{tags && tags.length > 0 && tags.map(tag => (
						<span className={getClassFromName(tag)}>{tag}</span>
					))}
				</div>
			</div>
		);
	};

	return (
		<div className="App-Furnitures-listing">
			<div className="furniture-header">
				<h3><BackArrow to="/inventory/furnitures" /> Liste de {currentCategory ? currentCategory.name : '...'}</h3>
				<div className="furniture-header-actions">
					<div className="furniture-create">
						<Icon isHM name="utilitary_plus" onClick={() => history.push(`/inventory/furnitures/${categoryid}/new`)} />
					</div>
					<div className="furniture-search">
						{ !displaySearch && <Icon isHM name="utilitary_search" onClick={() => setDisplaySearch(true)} /> }
						{ displaySearch && (
							<div className="search-field">
								<input
									type="text"
									onChange={(e) => setSearchQuery(e.target.value)}
									value={searchQuery}
									placeholder="Chercher une fourniture"
								/>
								<Icon
									isHM
									name="utilitary_close"
									onClick={() => {
										setDisplaySearch(false);
										setSearchQuery('');
									}}
								/>
							</div>
						)}
					</div>
				</div>
			</div>
			<div className="furnitures-list">
				{ !currentFurnitures && <p>Chargement...</p> }
				{ currentFurnitures && currentFurnitures.length === 0 && !searchQuery && <p>Pas de matières premières</p> }
				{ filteredFurnitures && filteredFurnitures.length === 0 && searchQuery && <p>Aucune fourniture trouvée</p> }
				{ filteredFurnitures && filteredFurnitures.length > 0 && filteredFurnitures.map(furniture => (
					<Link
						to={`/inventory/furnitures/${categoryid}/${furniture.id}/`}
						key={furniture.id}
						className="furnitures-item"
					>
						{furniture.name && getName(furniture.name) }
						<div className="furniture-stock">
							<span>en stock</span>
							{ furniture.stock_value !== null
								? <p>{furniture.stock_value}{furniture.stock_unit ? ` ${furniture.stock_unit}` : ''}</p>
								: <p>-</p> }
						</div>

					</Link>
				))}
			</div>
		</div>
	);
};

export default CategoryFurnitures;
